import styled from "styled-components";
import "@fontsource/open-sans";
import "@fontsource/open-sans/600.css";

const FormStyles = `
  width: 290px;
  height: 50px;
  border: 1px solid rgba(129, 140, 155, 0.4);
  border-radius: 8px;
  margin-bottom: 15px;
  padding: 16px;
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0.02em;
  color: #2e3539;
`;

const ContactsStyles = `
font-family: "Open Sans";
  letter-spacing: 0.02em;
  color: #818c9b;
  margin-left: 0;
  margin-right: 130px;
`;

export const UpperSection = styled.div`
  background: #f7f8fc;
  padding: 40px 40px 23px;
  text-align: center;

  @media (min-width: 768px) {
    padding-bottom: 40px;
  }

  @media (min-width: 1440px) {
    padding-top: 50px;
  }
`;

export const Text = styled.p`
  font-size: 17px;
  font-weight: 900;
  line-height: 31px;
  letter-spacing: 0.04em;
  color: #7165e3;
  margin-bottom: 30px;

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const FormImage = styled.img`
  @media (min-width: 768px) {
    width: 180px;
  }

  @media (min-width: 1440px) {
    width: 244px;
  }
`;

export const Form = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 55px 0 60px 0;
  margin: 0;

  @media (min-width: 768px) {
    padding-top: 70px;
    padding-bottom: 98px;
    margin-right: 10px;
  }
`;

export const FormWrapper = styled.div`
  @media (min-width: 768px) {
    display: flex;
    width: 768px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContactUs = styled(Text)`
  margin-bottom: 16px;
  width: auto;

  @media (min-width: 768px) {
    margin-bottom: 56px;
  }
`;

export const Label = styled.label`
  position: absolute;
  background: white;
  margin-top: -9px;
  padding: 0 6px;
  z-index: 1;
  color: red;
  margin-left: 20px;
`;

export const Input = styled.input`
  ${FormStyles}
  border: ${(props) =>
    props.error ? `1px solid red` : `1px solid rgba(129, 140, 155, 0.4)`};

  & :hover {
    border: 1px solid #7165e3;
  }

  & :focus {
    outline: none;
    border: 1px solid #7165e3;
  }

  ::placeholder {
    color: #818c9b;
  }

  :focus::placeholder {
    color: transparent;
  }

  @media (min-width: 768px) {
    width: 360px;
  }
`;

export const TextArea = styled.textarea`
  ${FormStyles}
  border: ${(props) =>
    props.error ? `1px solid red` : `1px solid rgba(129, 140, 155, 0.4)`};
  height: 160px;
  resize: none;
  margin-bottom: 30px;

  & :hover {
    border: 1px solid #7165e3;
  }

  & :focus {
    outline: none;
    border: 1px solid #7165e3;
  }

  ::placeholder {
    color: #818c9b;
  }

  :focus::placeholder {
    color: transparent;
  }

  @media (min-width: 768px) {
    width: 360px;
    margin-bottom: 50px;
  }
`;

export const Button = styled.button`
  width: 136px;
  height: 50px;
  border-radius: 8px;
  border: none;
  background: #ffd324;
  font-family: "Open Sans";
  font-weight: 600;
  cursor: pointer;
  color: #2e3539;
  outline: none;

  & :hover {
    background: #ffe065;
    box-shadow: 0 10px 20px 0 #ffeca2, 0 10px 20px 0 #ffeca2;
  }
`;
export const LowerWrapper = styled.div`
  background: #f7f8fc;
`;

export const LowerSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 16px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 100px 210px 60px 210px;
  }

  @media (min-width: 1440px) {
    width: 1440px;
    padding: 60px 150px 82px 150px;
    flex-direction: row;
    align-items: stretch;
  }
`;

export const DownloadSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1440px) {
    margin: 0;
  }
`;

export const ContactsSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1440px) {
    margin-right: 110px;
  }
`;

export const TextLowerFooter = styled(Text)`
  @media (min-width: 768px) {
    font-size: 24px;
    margin-bottom: 90px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 50px;
  }
`;

export const ButtonLink = styled.a`
  @media (min-width: 1440px) {
    margin-left: 0;
  }
`;

export const AppleFooterButton = styled.img`
  width: 150px;
  height: 50px;
  border-radius: 7px;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    width: 210px;
    height: 70px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 20px;
  }
`;

export const GoogleFooterButton = styled.img`
  width: 168px;
  border-radius: 6px;
  margin-bottom: 80px;

  @media (min-width: 768px) {
    width: 235px;
    height: 70px;
    margin-bottom: 100px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 0;
  }
`;

export const ContactsWrapper = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 290px;
  height: 154px;
  margin-bottom: 55px;

  @media (min-width: 1440px) {
    margin-bottom: 0;
  }
`;

export const ContactsTitle = styled(Text)`
  margin-bottom: 60px;

  @media (min-width: 768px) {
    font-size: 24px;
    margin-bottom: 80px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 50px;
    margin-left: 0;
  }
`;

export const Contacts = styled.p`
  ${ContactsStyles}
`;

export const Email = styled.a`
  ${ContactsStyles}
  text-decoration: none;
`;

export const Tel = styled.a`
  font-family: "Open Sans";
  letter-spacing: 0.02em;
  color: #818c9b;
  text-decoration: none;
`;

export const SocialUpWrapper = styled.div`
  width: 150px;
  transform: translate(59px, -90px);

  @media (min-width: 768px) {
    width: 188px;
    transform: translate(78px, -90px);
  }

  @media (min-width: 1440px) {
    transform: translate(0);
    margin: 0;
    width: 165px;
  }
`;

export const SocialWrapper = styled.div`
  width: 112px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  margin-right: 0;

  @media (min-width: 1440px) {
    width: 100%;
    margin-bottom: 140px;
  }
`;

export const SocialLink = styled.a`
  margin: 0;
`;

export const SocialIcon = styled.img`
  margin: 0;
  cursor: pointer;
`;

export const UpWrapper = styled.div`
  margin-left: 0;
  cursor: pointer;
  width: 40px;

  @media (min-width: 1440px) {
    margin-left: 125px;
  }
`;

export const ArrowFooter = styled.img`
  margin-bottom: 16px;
`;

export const Up = styled(Text)`
  margin: 0;
  width: 40px;
  font-size: 17px;
`;
